'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var strikePriceSizeMap = exports.strikePriceSizeMap = {
  large: [20, 10, 28],
  medium: [14, 8, 20],
  small: [12, 8, 16]
};

var priceSizeMap = exports.priceSizeMap = {
  large: [40, 20, 42],
  medium: [32, 16, 36],
  small: [24, 12, 24]
};

var priceTypeSizeMap = exports.priceTypeSizeMap = {
  large: 14,
  medium: 12,
  small: 12
};

var stikePriceBottomMap = exports.stikePriceBottomMap = {
  large: '1.3ex',
  medium: '1ex',
  small: '0.6ex'
};

var priceIconSizeMap = exports.priceIconSizeMap = {
  large: '28',
  medium: '24',
  small: '20'
};